import { useEffect, useRef } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledNumericFormat } from 'components/common'
import { Mode } from 'constants/index'
import { Restricted } from 'providers'
import { TBookingForm } from 'types'

interface IConsignmentFeeProps {
  mode?: number
  disabled?: boolean
}

export const ConsignmentFee = (_props: IConsignmentFeeProps) => {
  const { mode, disabled } = _props

  const isInitialMount = useRef<boolean>(true)

  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext<TBookingForm>()

  const [consignmentFeeFromTariff] = useWatch({
    name: ['consignmentFeeFromTariff', 'consignmentFee'],
  })

  // Subscriptions
  useEffect(() => {
    if (mode === Mode.Create && consignmentFeeFromTariff) {
      setValue('consignmentFee', consignmentFeeFromTariff)
      return
    }

    if (mode === Mode.Update) {
      if (!consignmentFeeFromTariff) {
        return
      }

      if (isInitialMount.current) {
        isInitialMount.current = false
        return
      }

      const currentConsignmentFee = getValues('consignmentFee')

      if (currentConsignmentFee !== consignmentFeeFromTariff) {
        setValue('consignmentFee', consignmentFeeFromTariff)
      }
    }
  }, [consignmentFeeFromTariff, getValues, mode, setValue])

  return (
    <Restricted
      to='MakeBookingConsignmentFeeFieldReadonly'
      fallback={
        <ControlledNumericFormat
          control={control}
          name='consignmentFee'
          label='Consignment Fee'
          disabled={disabled}
          required
          error={!!errors.consignmentFee}
          helperText={errors.consignmentFee?.message}
        />
      }>
      <ControlledNumericFormat
        control={control}
        name='consignmentFee'
        label='Consignment Fee'
        disabled={disabled}
        InputProps={{
          readOnly: true,
        }}
        required
        error={!!errors.consignmentFee}
        helperText={errors.consignmentFee?.message}
      />
    </Restricted>
  )
}
